import { Box, TextField } from "@mui/material";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";
import { Text } from "@src/appV2/redesign/components/Text";
import { type FormEvent, useState } from "react";

interface MobileLoginWithEmailAndPasswordFormProps {
  email: string;
  setEmail: (email: string) => void;
  password: string;
  setPassword: (password: string) => void;
  loading: boolean;
  onSubmit: () => Promise<void>;
  disabled?: boolean;
}

/**
 * Mobile-optimized email and password login form using Material UI
 */
export function MobileLoginWithEmailAndPasswordForm({
  email,
  setEmail,
  password,
  setPassword,
  loading,
  onSubmit,
  disabled = false,
}: MobileLoginWithEmailAndPasswordFormProps) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setIsSubmitting(true);
    try {
      await onSubmit();
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <Box
      component="form"
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
      }}
      onSubmit={(event) => {
        void handleSubmit(event);
      }}
    >
      <Text bold variant="h6" sx={{ textAlign: "center", marginBottom: 1 }}>
        Sign in with email and password
      </Text>

      <TextField
        fullWidth
        required
        type="email"
        label="Email"
        placeholder="your.email@example.com"
        value={email}
        disabled={disabled || loading}
        autoComplete="email"
        sx={{
          "& .MuiOutlinedInput-root": {
            fontSize: "1rem",
          },
        }}
        onChange={(event) => {
          setEmail(event.target.value);
        }}
      />

      <TextField
        fullWidth
        required
        type="password"
        label="Password"
        value={password}
        disabled={disabled || loading}
        autoComplete="current-password"
        sx={{
          "& .MuiOutlinedInput-root": {
            fontSize: "1rem",
          },
        }}
        onChange={(event) => {
          setPassword(event.target.value);
        }}
      />

      <LoadingButton
        fullWidth
        type="submit"
        variant="primary"
        size="large"
        isLoading={isSubmitting || loading}
        disabled={disabled}
      >
        Sign In
      </LoadingButton>
    </Box>
  );
}
